<label *ngIf="isStyled" class="label-sm-single" (click)="datepicker.openQuickOptionDropdown($event)">{{
  'signals-ng-filter-date.propertyLabels.timeframe' | translate
}}</label>
<ui2-datepicker
  #datepicker
  [placeholder]="placeholder !== undefined ? placeholder : ('signals-ng-filter-date.propertyLabels.publishedDateFilter' | translate)"
  [datePickerType]="ui2DatePickerType.QuickOptionsPicker"
  [quickOptions]="quickSelectOptions"
  [class.hide-cross-button]="hideCrossButton"
  [styled]="isStyled"
  [(ngModel)]="rangeDateSelectorModel"
  (ngModelChange)="select($event)"
  [customClass]="customClass"
  class="container {{ customClass }}"
></ui2-datepicker>
